import { formStoreLenses, formModuleLenses } from 'root/src/client/logic/form/lenses'
import { createProjectFormStepKeys } from 'root/src/shared/descriptions/modules/createProjectForm'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import currentRouteModuleTypes from 'root/src/client/logic/route/selectors/currentRouteModuleTypes'
import prop from 'ramda/src/prop'
import propEq from 'ramda/src/propEq'
import find from 'ramda/src/find'

const { root } = createProjectFormStepKeys
const { pathOrStepIdHistoryItem } = formStoreLenses
const { viewRootStepSelector } = formModuleLenses

export default (state, { moduleKey }) => {
	const moduleId = moduleKey && moduleIdFromKey(moduleKey)
	const currentRouteModuleType = prop(
		1, find(propEq(0, moduleId), currentRouteModuleTypes(state)),
	)
	const rootStepSelected = viewRootStepSelector(moduleId, moduleDescriptions)
	const rootStep = rootStepSelected ? rootStepSelected(state) : root
	return currentRouteModuleType === 'stepForm'
		? pathOrStepIdHistoryItem(moduleKey, 0, rootStep, state)
		: undefined
}
